import React from "react";
import GroupSubscription from "../../components/Group/GroupSubscription/GroupSubscription";
import NameHeading from "../../components/NameHeading";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectGroupById } from "../../features/groups/groupSlice";

const GroupViewSubscription: React.FC = () => {
  const { groupid } = useParams<{ groupid: string }>();
  const group = useAppSelector((state) => selectGroupById(state, groupid ?? ""));
  return (
    <>
      <div className="w-full h-[80vh] overflow-y-auto px-4 py-6">
        {group && <NameHeading name={group.name} />}
        <GroupSubscription />
      </div>
    </>
  );
};

export default GroupViewSubscription;
